module.exports = __webpack_public_path__ + "img/tiep-nhan-ho-so-icon.fcf20a95.svg";